import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { TASK } from '../constants';
import Card from './Card';

export default function Task(props) {
    return (
        <Draggable draggableId={props.task.id} index={props.index} isDragDisabled={!props.isEditModeEnabled}>
            {provided => (
                <div ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <Card type={TASK} card={props.task} isEditModeEnabled={props.isEditModeEnabled} />
                </div>
            )}
        </Draggable>
    );
};